var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1890_19522)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 3.48981C1.58203 2.71231 2.21231 2.08203 2.98981 2.08203H20.0076C20.7851 2.08203 21.4154 2.71231 21.4154 3.48981V20.5075C21.4154 21.285 20.7851 21.9153 20.0076 21.9153H2.98981C2.21231 21.9153 1.58203 21.285 1.58203 20.5075V3.48981Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03694 8.24186C6.98717 8.24186 7.75748 7.47155 7.75748 6.52132C7.75748 5.57109 6.98717 4.80078 6.03694 4.80078C5.08672 4.80078 4.31641 5.57109 4.31641 6.52132C4.31641 7.47155 5.08672 8.24186 6.03694 8.24186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3332 9.51338H12.1847V10.8197C12.1847 10.8197 12.9585 9.27208 15.0638 9.27208C16.9419 9.27208 18.4977 10.1973 18.4977 13.0173V18.964H15.5428V13.7379C15.5428 12.0743 14.6546 11.8914 13.9779 11.8914C12.5733 11.8914 12.3329 13.1029 12.3329 13.9549V18.964H9.3332V9.51338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53711 9.51339H7.53678V18.964H4.53711V9.51339Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 23,
    rx: 1.5,
    stroke: "#E2E8F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1890_19522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.227650f8565777e991d3722e847f6080.svg";
export { ForwardRef as ReactComponent };